export const Tag = {
  baseStyle: {},
  defaultProps: {
    variant: "subtle",
    size: "sm",
  },
};
